import React, { useState, useRef, useEffect, ReactNode } from 'react';
import './ResizeWrapper.scss';

interface ResizeWrapperProps {
  minWidth?: number;
  maxWidth?: number;
  initialWidth?: number;
  children: ReactNode;
  onWidthChange?: (width: number) => void;
}

const ResizeWrapper: React.FC<ResizeWrapperProps> = ({
  minWidth = 300,
  maxWidth = 800,
  initialWidth = 400,
  children,
  onWidthChange,
}) => {
  const [width, setWidth] = useState(initialWidth);
  const isResizing = useRef(false);

  const handleMouseDown = (e: React.MouseEvent) => {
    isResizing.current = true;
    document.body.style.cursor = 'ew-resize';
    document.body.classList.add('no-select');
  };
  const handleMouseMove = (e: MouseEvent) => {
    if (!isResizing.current) return;
    const wrapper = document.getElementById('resize-wrapper');
    if (!wrapper) return;
    const rect = wrapper.getBoundingClientRect();
    let newWidth = rect.right - e.clientX;
    newWidth = Math.max(minWidth, Math.min(maxWidth, newWidth));
    setWidth(newWidth);
  };
  const handleMouseUp = () => {
    isResizing.current = false;
    document.body.style.cursor = '';
    document.body.classList.remove('no-select');
    if (onWidthChange) onWidthChange(width);
  };
  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  });

  return (
    <div
      id="resize-wrapper"
      style={{
        width,
        minWidth,
        maxWidth,
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {children}
      <div
        style={{
          width: 8,
          cursor: 'ew-resize',
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 10,
          background: 'transparent',
        }}
        onMouseDown={handleMouseDown}
      />
    </div>
  );
};

export default ResizeWrapper;
